import {
  Publication,
  ResearchProject,
  ExperienceItem,
  Award,
  Talk,
} from "../types";

export const publications: Publication[] = [
  {
    number: 1,
    authors: "Mari A.",
    year: 2024,
    title:
      "Empathic voice assistants: Enhancing consumer responses in voice commerce",
    journal: "Journal of Business Research, 175, 114566",
    link: "https://www.sciencedirect.com/science/article/pii/S0148296324000705",
    status: "published",
  },
  {
    number: 2,
    authors: "Mari A.",
    year: 2025,
    title: "Harnessing AI Voice Assistants for Digital Corporate Communication",
    journal: "Corporate Communication Review, 1 (1), 40-45",
    link: "https://www.corpcommreview.com/corpcommreview/article/view/10/9",
    status: "published",
  },
  {
    number: 3,
    authors: "Mari A.",
    year: 2025,
    title:
      "AI with a Conscience: Empathic Voice Assistants for Sustainable Shopping Decisions",
    conference:
      "International Conference on Sustainability and Innovation Processes and Systems. Springer",
    status: "published",
  },
];

export const completedResearch: Publication[] = [
  {
    number: 1,
    authors: "Mari A.",
    year: 2024,
    title:
      "AI-Assisted Shopping on Voice Assistants: The Efficiency-Autonomy Consumer Decision Trade-Off",
    journal: "Journal of Interactive Marketing",
    status: "under-revision",
  },
  {
    number: 2,
    authors: "Mari A.",
    year: 2024,
    title:
      "Fear of Missing Out (FOMO) on Emerging AI Technology: Biased and Unbiased Adoption Decision Making",
    journal: "Technological Forecasting and Social Change",
    link: "https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4736154",
    status: "under-revision",
  },
  {
    number: 3,
    authors: "Efthymiou F., Mari A., Uysal E. & Brooks, J.",
    year: 2024,
    title:
      "No Hard Feelings: The Protective Power of AI Empathy During Service Interaction Failures",
    journal: "Journal of Service Research",
    link: "https://doi.org/10.31234/osf.io/4n9xy_v1",
    status: "under-revision",
  },
];

export const currentProjects: ResearchProject[] = [
  {
    id: 1,
    title: "AI Empathy in Retail: Empathic Voice Assistants as Shopping Agents",
    team: "Alex Mari (AUBH), Ertugrul Uysal (ETH Zurich), Jeffrey A. Brooks (Hume AI) & Amani Alabed (UDST)",
    abstract:
      "This project explores how empathic voice assistants influence consumer decision-making in the retail context.",
    fullAbstract:
      "This project explores how empathic voice assistants influence consumer decision-making in the retail context. Recognizing empathy as a critical factor in both interpersonal and market interactions, the study examines to what extent and under what conditions individuals rely on empathic AI for decision support. The research integrates Hume's Empathic Voice Interface (EVI) with the eBay catalog to create a shopping assistant capable of varying its empathy levels. Through simulated shopping scenarios involving both functional (e.g., batteries) and experiential (e.g., scented candles) products, the project investigates how AI empathy shapes user preferences, decision-making processes, and trust across different consumption contexts. This work aims to provide insights into both the positive and potential unintended consequences of deploying empathic AI in consumer markets.",
    link: "https://www.hume.ai/blog/case-study-hume-university-of-zurich",
  },
  {
    id: 2,
    title:
      "Voicing Sustainability: Designing Empathic and Persuasive AI Voice Assistants for Sustainable Shopping",
    team: "Alex Mari (AUBH), Amani Alabed (UDST), Fotis Efthymiou (AI Empathy), Ertugrul Uysal (ETH Zurich) & Jeffrey A. Brooks (Hume AI)",
    abstract:
      "This project investigates how empathic AI-powered voice assistants can promote sustainable consumption.",
    fullAbstract:
      "This project investigates how empathic AI-powered voice assistants can promote sustainable consumption. As conversational AI agents like ChatGPT and Claude become deeply integrated into consumers' daily lives, voice-based interactions offer unique opportunities to influence not only product choices but also underlying consumer values. Unlike traditional e-commerce, VAs enable highly personalized, emotionally attuned conversations that can align with users' sustainability goals. Despite growing interest in sustainable consumption, a persistent gap remains between consumers' intentions and actual behaviors. This study explores whether empathic and persuasive capabilities of VAs can help close this gap by acting as ethical digital advisors—regulating emotions, providing moral nudges, and fostering value-driven decisions. Addressing a key theoretical gap, the project examines how AI empathy and persuasion in real-time voice interactions can ethically guide consumers toward more sustainable choices.",
  },
  {
    id: 3,
    title:
      "AI Memory: A Field Experiment on the Effects of Memory in AI Companions on Older Adults",
    team: "Alex Mari (AUBH), Ertugrul Uysal (ETH Zurich), Amani Alabed (UDST) & Jeffrey A. Brooks (Hume AI)",
    abstract:
      "This project examines the impact of AI companions equipped with memory on the well-being and behaviors of older adults.",
    fullAbstract:
      "This project examines the impact of AI companions equipped with memory on the well-being and behaviors of older adults. Focusing on the role of memory in human-AI interactions, the study examines whether AI companions that recall past conversations can reduce loneliness, enhance cognitive stimulation, and foster stronger perceived relationships both with the AI and with others. In a field experiment, seniors interact with AI companions either with or without memory functions, allowing researchers to assess differences in emotional outcomes and relational dynamics. The project also explores how these social-emotional experiences, including perceptions of AI empathy, shape users' willingness to adopt AI-suggested health behaviors related to diet, sleep, and physical activity. The findings aim to inform the ethical design of AI companions that support emotional well-being and healthy aging.",
  },
];

export const awards: Award[] = [
  {
    year: 2022,
    category: "Academia",
    title: "Stanley C. Hollander for Best Retailing Paper",
    organization: "Academy of Marketing Science",
  },
  {
    year: 2016,
    category: "Industry",
    title: "Top 50 Marketing Technology Influencers",
    organization: "Onalytica",
  },
  {
    year: 2012,
    category: "Corporate",
    title: 'Leadership Award "Power of You"',
    organization: "P&G (Vice President)",
  },
];

export const invitedTalks: Talk[] = [
  {
    number: 21,
    year: 2025,
    title: "EU Business School",
    event: "Geneva, Switzerland",
    location: "Prof. Liouka",
    host: "Prof. Liouka",
  },
  {
    number: 20,
    year: 2024,
    title: "Sasin School of Management",
    event: "Thailand",
    location: "Prof. Connelly",
    host: "Prof. Connelly",
  },
  {
    number: 19,
    year: 2024,
    title: "Thammasa Business School",
    event: "Thailand",
    location: "Prof. Charinsarn",
    host: "Prof. Charinsarn",
  },
  // Add more talks as needed
];

export const experience: ExperienceItem[] = [
  {
    id: 1,
    position: "Assistant Professor of Marketing and Management",
    company: "American University of Bahrain",
    location: "Bahrain",
    dateRange: "07/25 - Present",
    description: "College of Business and Management",
    category: "teaching",
  },
  {
    id: 2,
    position: "Visiting Professor of Marketing Analytics",
    company: "Catholic University of Sacred Heart",
    location: "Italy",
    dateRange: "09/24 - Present",
    category: "teaching",
  },
  {
    id: 3,
    position: "Co-founder and Research Scientist",
    company: "AI Empathy Research Initiative",
    location: "Switzerland",
    dateRange: "07/24 - Present",
    category: "research",
  },
  {
    id: 4,
    position: "Global Director of Digital Marketing & E-Commerce",
    company: "Sonova Group",
    location: "Switzerland",
    dateRange: "08/15 - 12/16",
    category: "managerial",
  },
  {
    id: 5,
    position: "Founder",
    company: "Cary Ally",
    location: "Switzerland",
    dateRange: "01/25 - Present",
    category: "entrepreneurial",
  },
];

export const education: ExperienceItem[] = [
  {
    id: 1,
    position: "Doctorate in Business Administration, Marketing",
    company: "University of Zurich",
    location: "Switzerland",
    dateRange: "2018 - 2024",
    category: "education",
  },
  {
    id: 2,
    position: "Visiting PhD Program, Strategic Management",
    company: "Said Business School, University of Oxford",
    location: "UK",
    dateRange: "2020 - 2021",
    category: "education",
  },
  {
    id: 3,
    position: "Master of Science in Communication and Economics, Marketing",
    company: "University of Lugano",
    location: "Switzerland",
    dateRange: "2007 - 2010",
    category: "education",
  },
];
